import React from "react";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Switch,
  Divider,
  Collapse,
} from "antd";
import { FormListFieldData } from "antd/lib/form/FormList";
import Image from "@src/packages/pro-component/schema/Image";
import RichText from "@src/components/Widget/RichText";
import SingleModel from "@src/packages/pro-component/schema/SingleModel";
import { FormInstance } from "antd/lib/form";
import { PlusOutlined, DeleteOutlined, TagsOutlined } from "@ant-design/icons";

interface TicketsSectionProps {
  fields: FormListFieldData[];
  add: (initialValue?: any, insertIndex?: number) => void;
  remove: (index: number | number[]) => void;
  form: FormInstance;
  pageId?: number;
}

const TicketsSection: React.FC<TicketsSectionProps> = ({
  fields,
  add,
  remove,
  form,
  pageId,
}) => {
  return (
    <>
      <div
        style={{
          marginBottom: 12,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() =>
            add({
              metaData: [
                { name: "GATE", value: "" },
                { name: "ZONE", value: "" },
                { name: "FLOOR", value: "" },
                { name: "SEAT", value: "" },
              ],
            })
          }
        >
          Thêm vé
        </Button>
      </div>
      <Collapse defaultActiveKey={fields.map((f) => String(f.key))}>
        {fields.map((field) => (
          <Collapse.Panel
            header={
              <Form.Item noStyle shouldUpdate>
                {() => {
                  const idx = field.name as number;
                  const ticketName = form.getFieldValue([
                    "ticket",
                    idx,
                    "name",
                  ]);
                  const title = ticketName
                    ? `Vé: ${ticketName}`
                    : `Vé #${idx + 1}`;
                  return (
                    <span style={{ fontWeight: "bold" }}>
                      <TagsOutlined style={{ marginRight: 8 }} />
                      {title}
                    </span>
                  );
                }}
              </Form.Item>
            }
            key={String(field.key)}
            extra={
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  remove(field.name);
                }}
              >
                Xóa
              </Button>
            }
          >
            <Form.Item
              {...field}
              name={[field.name, "id"]}
              fieldKey={[field.fieldKey!, "id"]}
              style={{ display: "none" }}
            >
              <Input type="hidden" />
            </Form.Item>
            <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item
                  {...field}
                  name={[field.name, "name"]}
                  fieldKey={[field.fieldKey!, "name"]}
                  label="Tên vé"
                  rules={[{ required: true, message: "Nhập tên vé" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  {...field}
                  name={[field.name, "image"]}
                  fieldKey={[field.fieldKey!, "image"]}
                  label="Ảnh vé"
                  rules={[{ required: true, message: "Chọn ảnh" }]}
                >
                  <Image />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              {...field}
              name={[field.name, "description"]}
              fieldKey={[field.fieldKey!, "description"]}
              label="Mô tả"
              rules={[{ required: true, message: "Nhập mô tả" }]}
            >
              <RichText height={200} />
            </Form.Item>
            <Divider orientation="left">Giá & Số lượng</Divider>
            <Row gutter={12}>
              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  {...field}
                  name={[field.name, "price"]}
                  fieldKey={[field.fieldKey!, "price"]}
                  label="Giá bán"
                  rules={[{ required: true, message: "Nhập giá" }]}
                >
                  <InputNumber style={{ width: "100%" }} min={0} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  {...field}
                  name={[field.name, "originPrice"]}
                  fieldKey={[field.fieldKey!, "originPrice"]}
                  label="Giá gốc"
                  rules={[{ required: true, message: "Nhập giá gốc" }]}
                >
                  <InputNumber style={{ width: "100%" }} min={0} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  {...field}
                  name={[field.name, "quantity"]}
                  fieldKey={[field.fieldKey!, "quantity"]}
                  label="Số lượng"
                  rules={[{ required: true, message: "Nhập số lượng" }]}
                >
                  <InputNumber style={{ width: "100%" }} min={0} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  {...field}
                  name={[field.name, "status"]}
                  fieldKey={[field.fieldKey!, "status"]}
                  label="Kích hoạt"
                  valuePropName="checked"
                  rules={[{ required: true }]}
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
            <Divider orientation="left">Giới hạn</Divider>
            {/* <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item
                  {...field}
                  name={[field.name, "startDateSell"]}
                  fieldKey={[field.fieldKey!, "startDateSell"]}
                  label="Bắt đầu bán"
                  rules={[{ required: true, message: "Chọn thời gian" }]}
                >
                  <Input type="datetime-local" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  {...field}
                  name={[field.name, "endDateSell"]}
                  fieldKey={[field.fieldKey!, "endDateSell"]}
                  label="Kết thúc bán"
                  rules={[{ required: true, message: "Chọn thời gian" }]}
                >
                  <Input type="datetime-local" />
                </Form.Item>
              </Col>
            </Row> */}
            <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item
                  {...field}
                  name={[field.name, "maxItemsPerOrder"]}
                  fieldKey={[field.fieldKey!, "maxItemsPerOrder"]}
                  label="Tối đa / đơn"
                  rules={[{ required: true }]}
                >
                  <InputNumber style={{ width: "100%" }} min={1} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  {...field}
                  name={[field.name, "minItemsPerOrder"]}
                  fieldKey={[field.fieldKey!, "minItemsPerOrder"]}
                  label="Tối thiểu / đơn"
                  rules={[{ required: true }]}
                >
                  <InputNumber style={{ width: "100%" }} min={1} />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left">Metadata vé</Divider>
            <Form.List name={[field.name, "metaData"]}>
              {(metaFields, { add: addMeta, remove: removeMeta }) => (
                <>
                  {metaFields.map((mf, idx) => (
                    <Row
                      key={mf.key}
                      gutter={12}
                      align="middle"
                      style={{ marginBottom: 12 }}
                    >
                      <Col
                        xs={4}
                        sm={3}
                        md={2}
                        style={{ textAlign: "right", paddingRight: 8 }}
                      >
                        {idx + 1}
                      </Col>
                      <Col xs={20} sm={9} md={8}>
                        <Form.Item
                          {...mf}
                          name={[mf.name, "name"]}
                          fieldKey={[mf.fieldKey!, "name"]}
                          rules={[
                            { required: true, message: "Tên thuộc tính" },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            placeholder="Tên thuộc tính"
                            disabled={(() => {
                              // Khóa name nếu thuộc meta chung (có __gid)
                              const g = form.getFieldValue(["metaData"]) || [];
                              const thisName = form.getFieldValue([
                                "ticket",
                                field.name,
                                "metaData",
                                mf.name,
                                "name",
                              ]);
                              const key = (x: any) =>
                                x?.__gid
                                  ? `gid:${x.__gid}`
                                  : `name:${String(
                                      x?.name || ""
                                    ).toUpperCase()}`;
                              const curKey = `name:${String(
                                thisName || ""
                              ).toUpperCase()}`;
                              const isGlobal =
                                Array.isArray(g) &&
                                g.some(
                                  (it: any) =>
                                    key(it) === curKey ||
                                    (!!it?.__gid &&
                                      it.__gid ===
                                        form.getFieldValue([
                                          "ticket",
                                          field.name,
                                          "metaData",
                                          mf.name,
                                          "__gid",
                                        ]))
                                );
                              const s = String(thisName || "").toUpperCase();
                              return (
                                isGlobal ||
                                ["GATE", "ZONE", "FLOOR", "SEAT"].includes(s)
                              );
                            })()}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={20} sm={9} md={10}>
                        <Form.Item
                          {...mf}
                          name={[mf.name, "value"]}
                          fieldKey={[mf.fieldKey!, "value"]}
                          rules={[{ required: true, message: "Giá trị" }]}
                          style={{ marginBottom: 0 }}
                        >
                          {(() => {
                            const v = form.getFieldValue([
                              "ticket",
                              field.name,
                              "metaData",
                              mf.name,
                              "name",
                            ]);
                            const s = String(v || "").toUpperCase();
                            if (s === "GATE") {
                              return (
                                <SingleModel
                                  schema={{
                                    pageId: pageId || 120,
                                    api: "find_checkinGate",
                                    modelSelectMultiple: false,
                                    modelSelectField: "id$$ID,name$$Tên cổng",
                                  }}
                                />
                              );
                            }
                            return <Input placeholder="Giá trị" />;
                          })()}
                        </Form.Item>
                      </Col>
                      <Col xs={4} sm={3} md={2}>
                        <Button
                          danger
                          icon={<DeleteOutlined />}
                          onClick={() => removeMeta(mf.name)}
                          disabled={(() => {
                            const v = form.getFieldValue([
                              "ticket",
                              field.name,
                              "metaData",
                              mf.name,
                              "name",
                            ]);
                            const s = String(v || "").toUpperCase();
                            return ["GATE", "ZONE", "FLOOR", "SEAT"].includes(
                              s
                            );
                          })()}
                        >
                          Xóa
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => addMeta({ name: "", value: "" })}
                    style={{ marginLeft: "8%" }}
                  >
                    Thêm thuộc tính
                  </Button>
                </>
              )}
            </Form.List>
          </Collapse.Panel>
        ))}
      </Collapse>
    </>
  );
};

export default TicketsSection;
